export enum ContractDetailView {
    DefaultView = 'DefaultView',
    ProductDetail = 'ProductDetail',
    SelectedItemActions = 'SelectedItemActions'
}
